import React, { CSSProperties, useContext } from 'react';
import { ElementConfigType } from '../store/type';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import ComponentItemRender from './ComponentItemRender';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { DroppableHOC } from '../HOC';
import { lazy } from 'ice';

interface Iheight {
  height?: string;
  className?: string;
  tip?: string;
  styles?: CSSProperties;
  wrapperId?: string;
}

export type Props = ElementConfigType & Iheight;

const DroppableComponent = DroppableHOC(lazy(() => import('./DroppableComponentInBasicRender')));

export const ComponentBasicRender: MyComponentType<Props> = (props: Props) => {
  const { elements, styles, className, wrapperId = '' } = props;
  const pageEditorStore = useContext(PageEditorStoreContext);
  const _styles = Object.assign(styles, {});

  return (
    <>
      <div id={wrapperId} className={className} style={Array.isArray(_styles) ? {} : _styles}>
        {elements.map((item) => (
          <ComponentItemRender {...toJS(item)} key={item.nodeId} />
        ))}

        {pageEditorStore.isDevelopment && <DroppableComponent {...props} />}
      </div>
    </>
  );
};

ComponentBasicRender.definition = {
  // id: 'Basic-Component', // 基本容器
  id: ComponentIdEnum.BASIC_COMPONENT, // 基本容器
  name: '基本容器',
  icon: '',
  privateSchema: [],
  config: {},
  configForm: [],
};
